<template>
  <tr>
    <template v-for="(field, index) in fields">
      <td v-if="!editMode || !field.editable" :key="`display${record.id}${index}`">
        <template v-if="field.type == 'String'">
          {{fieldValue(field.key)}}
        </template>
        <template v-if="field.type == 'Number'">
          {{fieldValue(field.key)}}
        </template>
        <template v-if="field.type == 'Percentage'">
          {{percentageDisplay(fieldValue(field.key))}}
        </template>
        <template v-if="field.type == 'Date'">
          {{dateDisplay(fieldValue(field.key))}}
        </template>
        <template v-if="field.type == 'Duration'">
          {{formatDuration(fieldValue(field.key))}}
        </template>
        <template v-if="field.type == 'Boolean'">
            <input type="checkbox" v-model="modelValues[field.key]" disabled>
        </template>
        <template v-if="field.type == 'Reference' && record[field.key]">
          {{referenceDisplay(field.key,record[field.key].id)}}
        </template>
        <template v-if="field.type == 'URL'">
          <a v-bind:href="fieldValue(field.key)" target="_blank">{{fieldValue(field.key)}}</a>
        </template>
      </td>
      <td v-if="editMode && field.editable" :key="`display${record.id}${index}`">
        <template v-if="field.type == 'String'">
          <input type="text" v-model="modelValues[field.key]">
        </template>
        <template v-if="field.type == 'Number'">
          <input type="number" v-model.number="modelValues[field.key]">
        </template>
        <template v-if="field.type == 'Date'">
          <input type="date" v-model="modelValues[field.key]">
        </template>
        <template v-if="field.type == 'Duration'">
          <input type="number" v-model.number="modelValues[field.key]">
        </template>
        <template v-if="field.type == 'Boolean'">
          <input type="checkbox" v-model="modelValues[field.key]">
        </template>
        <template v-if="field.type == 'Reference'">
          <select v-model="modelValues[field.key]">
            <option v-for="refRecord in referencedArray(field.key)" v-bind:value="refRecord.id" v-bind:key="refRecord.id">
              {{ refRecord.displayName ? refRecord.displayName : refRecord.name }}
            </option>
          </select>
        </template>
      </td>
    </template>
    <td v-if="!editMode">
      <span class="material-icons icon-button" v-on:click="engageEditMode">edit</span>
      <span class="material-icons icon-button" v-on:click="deleteItem">delete</span>
    </td>
    <td v-else>
      <button v-on:click="cancelEdit">Cancel</button>
      <button v-if="updateObj" v-on:click="saveChanges">Save Changes</button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';


export default {
  name: 'FirebaseRow',
  data () {
    var dataObj = {
      editMode: false,
      modelValues: {}
    }
    //console.log(this.fields)
    this.fields.forEach((field)=>{
      if (field.editable) {
        var fieldValue = this.fieldValue(field.key)
        if (field.type == 'Reference' && fieldValue) {
          dataObj.modelValues[field.key] = fieldValue.id
        } else if (field.type == 'Date' && fieldValue) {
          dataObj.modelValues[field.key] = moment(fieldValue.seconds*1000).format("YYYY-MM-DD")
        } else {
          dataObj.modelValues[field.key] = this.fieldValue(field.key)
        }
      }
    })
    //console.log(dataObj);
    return dataObj
  },
  props: {
    record: Object,
    fields: Array,
    collection: String
  },
  computed: {
    updateObj(){
      var updateItems = {}
      this.fields.forEach((field)=>{
        if (this.modelValues[field.key] != undefined){
          var initialValue
          if (field.type == 'Reference' && this.fieldValue(field.key)) {
            initialValue = this.fieldValue(field.key).id
          } else if (field.type == 'Date' && this.fieldValue(field.key)) {
            initialValue = moment(this.fieldValue(field.key).seconds*1000).format("YYYY-MM-DD")
          } else {
            initialValue = this.fieldValue(field.key)
          }
          //console.log(`${field.key}: ${initialValue} != ${this.modelValues[field.key]}`);
          //check values
          if (initialValue != this.modelValues[field.key]) {

            var splitKeys = field.key.split(".");
            var updateValue
            if (field.type == 'Reference') {
              updateValue = this.referenceRef(field.key,this.modelValues[field.key])
            } else if (field.type == 'Date') {
              updateValue = moment(this.modelValues[field.key], "YYYY-MM-DD").toDate()
            } else {
              updateValue = this.modelValues[field.key]
            }
            //Nest values
            if (splitKeys.length === 1) {
              updateItems[field.key] = updateValue
            }
            if (splitKeys.length === 2) {
              if (!updateItems[splitKeys[0]]) {
                updateItems[splitKeys[0]] = {}
              }
              updateItems[splitKeys[0]][splitKeys[1]] = updateValue
            }
          }
        }
      })
      if (Object.keys(updateItems).length > 0) {
        return updateItems
      } else {
        return false
      }
    }
  },
  methods: {
    formatDuration (rawSeconds) {
      if (rawSeconds != null) {
        var minutes = Math.floor(rawSeconds / 60);
        var seconds = Math.floor(rawSeconds % 60)
        var prettySeconds
        var prettyMinutes
        if (seconds < 10) {
          prettySeconds = "0" + seconds
        } else {
          prettySeconds = seconds
        }
        if (minutes > 0) {
          prettyMinutes = minutes
        } else {
          prettyMinutes = 0
        }
        return prettyMinutes + ":" + prettySeconds
      } else {
        return null
      }
    },
    fieldValue (key) {
      var splitKeys = key.split(".");
      if (splitKeys.length === 1) {
        if (this.record[key]) {
          return this.record[key]
        } else {
          return null
        }

      }
      if (splitKeys.length === 2) {
        if (this.record[splitKeys[0]]) {
          return this.record[splitKeys[0]][splitKeys[1]]
        } else {
          return null
        }
      }
      if (splitKeys.length === 3) {
        if (this.record[splitKeys[0]]) {
          return this.record[splitKeys[0]][splitKeys[1]][splitKeys[2]]
        } else {
          return null
        }
      }
    },
    dateDisplay (dateValue) {
      if (dateValue) {
        return moment(dateValue.seconds*1000).format('dddd, MMMM Do, YYYY')
      } else {
        return null
      }

    },
    percentageDisplay (percentageValue) {
      if (percentageValue) {
        var percent = percentageValue*100
        return `${percent.toFixed(2)}%`
      } else {
        return null
      }
    },
    referenceDisplay (collection, id) {
      if (this.$store.state[`${collection}Collection`][id]) {
        return this.$store.state[`${collection}Collection`][id].name
      } else {
        return ""
      }

    },
    referenceRef (collection, id) {
      return this.$store.state[`${collection}Collection`][id].ref
    },
    referencedArray (collection) {
      return this.$store.getters[`${collection}Array`]
    },
    engageEditMode() {
      this.editMode = true
    },
    cancelEdit() {
      this.fields.forEach((field)=>{
        if (field.editable) {
          var fieldValue = this.fieldValue(field.key)
          if (field.type == 'Reference' && fieldValue) {
            this.modelValues[field.key] = fieldValue.id
          } else if (field.type == 'Date' && fieldValue) {
            this.modelValues[field.key] = moment(fieldValue.seconds*1000).format("YYYY-MM-DD")
          } else {
            this.modelValues[field.key] = this.fieldValue(field.key)
          }
        }
      })
      this.editMode = false
    },
    saveChanges() {
      this.$store.dispatch('updateFirebaseRecord',[this.record.ref,this.updateObj])
      this.editMode = false
    },
    deleteItem (){
      var storeVar = this.$store
      var itemRef = this.record.ref
      var itemName = this.record.name ? this.record.name : "this item"
      var dialogOptions = {
        okText: 'Delete',
        cancelText: 'Cancel',
        backdropClose: true
      }
      this.$dialog.confirm(`Are you sure you want to delete ${itemName}?`,dialogOptions).then(function() {
        storeVar.dispatch('deleteFirebaseRecord',itemRef)
      }).catch(function() {
      });
    },
  }
}
</script>

<style scoped>
  td {
    border: 2px solid #2E303A;
    font-size: 14px;
  }
  td, th {
    padding: 15px;
  }
</style>
